module.exports = __webpack_public_path__ + "img/T6-B-xh_14.58bcecc1.png";